import axios from 'axios';
import { hdpApiBase } from '../config/api';
import { clearAuthSession, redirectIfProtectedPath } from './authSession';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

function detectHdpModule(url) {
  if (url.startsWith('/hdp/evidence') || url.startsWith('/hdp/files')) {
    return 'evidence';
  }
  if (url.startsWith('/hdp/personas')) {
    return 'personas';
  }
  if (url.startsWith('/hdp/iocs') || url.startsWith('/hdp/enrichment')) {
    return 'iocs';
  }
  if (url.startsWith('/hdp/reports')) {
    return 'reports';
  }
  if (url.startsWith('/hdp/actors')) {
    return 'actors';
  }
  return 'cases';
}

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token and route HDP calls to Django when flagged
api.interceptors.request.use(
  (config) => {
    const url = config.url || '';
    if (url.startsWith('/hdp/')) {
      config.baseURL = hdpApiBase(detectHdpModule(url));
    } else {
      config.baseURL = API_BASE_URL;
    }

    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      if (config.headers) {
        delete config.headers['Content-Type'];
        if (config.headers.common) delete config.headers.common['Content-Type'];
      }
    }

    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor for token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          const response = await axios.post(`${API_BASE_URL}/auth/refresh`, null, {
            headers: {
              Authorization: `Bearer ${refreshToken}`,
            },
          });

          const { access_token } = response.data;
          localStorage.setItem('token', access_token);

          originalRequest.headers.Authorization = `Bearer ${access_token}`;
          return api(originalRequest);
        } catch (refreshError) {
          clearAuthSession();
          redirectIfProtectedPath();
        }
      } else if (error.response?.status === 401) {
        clearAuthSession();
        redirectIfProtectedPath();
      }
    }

    return Promise.reject(error);
  },
);

export default api;
